import type { FC } from 'react';

import { useContent } from '@eneco/cms';

import type { TitleTextCTAContent } from './title-text-cta-content.types';
import { TitleTextCTAView } from './TitleTextCTAView';

/**
 * `TitleTextCTA` block for the CMS-agnostic lane, serving **both** providers.
 *
 * Render body lives in `TitleTextCTAView.tsx`, shared with `PersonalizedTitleTextCTA` — see that
 * file's doc comment for why.
 */
const TitleTextCTA: FC = () => {
  const content = useContent<TitleTextCTAContent>();

  return <TitleTextCTAView title={content.title} content={content} />;
};

export default TitleTextCTA;
